<template>
  <div>
    <PageAllow controller="Campaigns" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherKeyword
                v-model="options.name"
                @text="KeyWord = $event"
                :label="$t('Campaigns.name')"
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                small
                color="primary"
                class="ms-1"
                @click.stop="$router.push('/campaign/select-type')"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("Campaigns.newInfo") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="options.types"
                    clearable
                    :items="$consts.activitiesType"
                    :label="$t('Campaigns.type')"
                    item-text="name"
                    item-value="type"
                    chips
                    small-chips
                    deletable-chips
                    multiple
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('Campaigns.status.title')"
                    :items="$consts.campaignsType"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="campaigns"
          :options.sync="options"
          :loading="loading"
          mobile-breakpoint="800"
          multi-sort
          :page.sync="paging.page"
          :server-items-length="paging.count"
          class="elevation-2 px-4 pt-1"
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:item.name="{ item }">
            <span>{{ item.name }}</span>
            <br />
            <span class="caption secondary--text">
              {{ item.description }}
            </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              small
              dark
              color="info"
              class="px-2 me-2 mb-1"
              @click.stop="
                $router.push('/campaign/' + item.id + '?type=' + item.type)
              "
            >
              {{ $t("Campaigns.action.detail") }}
            </v-btn>
            <v-btn
              v-if="item.status == 0"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1"
              @click.stop="
                $router.push({
                  path: 'campaign/' + item.id,
                  query: { type: item.type, mode: 'edit' },
                })
              "
            >
              {{ $t("Campaigns.action.edit") }}
            </v-btn>
            <!-- 启用 -->
            <v-btn
              v-if="item.status == 0"
              small
              dark
              color="primary"
              class="px-2 me-2 mb-1"
              @click.stop="changeStatus(item.id)"
            >
              {{ $t("Campaigns.action.on") }}
            </v-btn>
            <!-- 停止启用 -->
            <v-btn
              v-if="item.status == 1"
              small
              dark
              color="orange"
              class="px-2 me-2 mb-1"
              @click.stop="changeStatus(item.id)"
            >
              {{ $t("Campaigns.action.off") }}
            </v-btn>
            <!-- 作废 -->
            <v-btn
              v-if="item.status == 0 || item.status == 1"
              small
              dark
              color="danger"
              class="px-2 me-2 mb-1"
              @click.stop="cancel(item.id)"
            >
              {{ $t("Campaigns.action.cancel") }}
            </v-btn>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | CampaignsColor"
              :text-color="item.status | CampaignsTextColor"
              >{{ item.status | CampaignsText }}
            </v-chip>
          </template>
        </v-data-table>
      </div></v-sheet
    >
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import i18n from "@/i18n";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import Campaigns from "@/api/campaigns";
import { mapState } from "vuex";

const defaultOptions = {
  name: "",
  status: [0, 1],
  types: [],
};

export default {
  data: () => ({
    options: JSON.parse(
      sessionStorage.getItem("campaign-options")
        ? sessionStorage.getItem("campaign-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    campaigns: [],
  }),

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.materialManagement"),
        disabled: false,
        href: "/materials",
      },
      {
        text: i18n.t("Nav.campaign"),
        disabled: true,
        href: "/campaign",
      },
    ],

    headers: () => [
      {
        text: i18n.t("Campaigns.Fields.name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("Campaigns.Fields.type"),
        align: "start",
        sortable: false,
        value: "type_str",
      },
      {
        text: i18n.t("Campaigns.Fields.ladder_flg_str"),
        align: "start",
        sortable: false,
        value: "ladder_flg_str",
      },
      {
        text: i18n.t("Campaigns.Fields.date_from"),
        align: "start",
        sortable: false,
        value: "date_from",
      },
      {
        text: i18n.t("Campaigns.Fields.date_to"),
        align: "start",
        sortable: false,
        value: "date_to",
      },
      {
        text: i18n.t("Campaigns.Fields.order"),
        align: "start",
        sortable: false,
        value: "order_cnt",
      },
      {
        text: i18n.t("Campaigns.Fields.pub_flg"),
        align: "start",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("Campaigns.Fields.action"),
        align: "start",
        sortable: false,
        value: "action",
      },
    ],
    ...mapState(["loading", "stickTableCols"]),
  },
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherStatus,
  },
  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        name: this.KeyWord,
      });
    },
    resetSearch() {
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    getCampaignsFromAPI() {
      Campaigns.fetch(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.campaigns = response.data.campaigns;
            this.paging = response.data.paging;
          }
        }.bind(this)
      );
    },
    cancel(id) {
      Campaigns.cancel(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getCampaignsFromAPI();
          }
        }.bind(this)
      );
    },
    changeStatus(id) {
      Campaigns.statusUpdate(id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.getCampaignsFromAPI();
          }
        }.bind(this)
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        sessionStorage.setItem(
          "campaign-options",
          JSON.stringify(this.options)
        );
        this.getCampaignsFromAPI();
      },
    },
  },
};
</script>

<style>
</style>